import store from '../store';
import Agent from '../views/agent/Index.vue'
import AgentsOrder from "@/views/agent/Orders";
import {checkauth} from "../Helper";

export default [
    {
        path: '/agents',
        name: 'agents',
        component: Agent,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    // console.log(response)
                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },
    {
        path: '/agents-order',
        name: 'agents-order',
        component: AgentsOrder,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    // console.log(response)
                    if(response){
                        //console.log("login")
                        next();
                    }else{
                        //console.log("next")
                        next('/login');
                    };
                }

            )
        }
    },


]
